import abt from "../assets/images/abt.png"
const About = () => {
    return (
        <main className="max-w-[1000px] px-2 mx-auto">
            <h1 className="text-3xl text-center mt-6 font-bold">About Us</h1>
            <div className="flex justify-between flex-wrap align-center mt-[20px]">
                <div className="max-w-[500px]">
                    {/* <h2>about Swift Mart</h2> */}
                    <p>Swift Mart is a platform in Nigeria, where all can trade whatever business they have by selecting the category that matches their product and meet
                        potential buyers that are within their school. You can also list out services you have to offer and meet potential clients 
                    </p>

                    <h2 className="mt-5 font-semibold">Disclamer</h2>
                    <p>
                        Every business transactions done outside the school and client or customer was gotten from this app
                        if issue arrises with the business in future note we are not responsible every business is to be done
                        within the school enviro and in a well secured location not meeting with vendors or customers in a
                        closed system due to security reasons for scammers may arise in pretence of selling
                    </p>

                    <h2 className="mt-5 font-semibold">Features</h2>
                    <ul>
                        <li>Run Ads</li>
                        <li>Active Location</li>
                        <li>Unlimited Access</li>
                        <li>UI Friendly</li>
                    </ul>
                </div>
                <div className="max-w-[300px]">
                    <img src={abt} alt="about-pic" className="w-[100%]" />
                </div>
            </div>
        </main>
    )
}

export default About;